export default "__VITE_ASSET__DOjap7Im__"